// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3FEO2","box":"WorkspacesBox_box__1yGXB","node":"WorkspacesBox_node__KWgmO"};